import script from "./overview-navigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./overview-navigation.vue?vue&type=script&lang=ts&setup=true"

import "./overview-navigation.vue?vue&type=style&index=0&id=51815d73&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51815d73"]])

export default __exports__